import axios from 'axios'
import http, {
  videoAiInstance,
  questionAnswerAiInstance,
  draftVideoInstance,
  videoCheckInstance
} from './http'
import { config } from '../../constants'
import { getSession } from './user'

function changeMachineState(state) {
  return videoAiInstance({
    method: 'GET',
    url: `/default/video-generation-comfy?machine_state=${state}`
  })
}

function generateVideo(data) {
  return videoAiInstance({
    method: 'POST',
    url: '/default/video-generation-comfy',
    data
  })
}

function generateShots(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/shots-generation-v2',
    data
  })
}

function mapCharacterToShots(data) {
  return questionAnswerAiInstance({
    method: 'POST',
    url: '?service=character-mapping',
    data
  })
}

function groupShotsToScenes(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/cluster-scenes',
    data
  })
}

function generateVideoStory(data) {
  return questionAnswerAiInstance({
    method: 'POST',
    url: '?service=video-story-generation',
    data
  })
}

function getAvailableCharacters(data = {}) {
  return draftVideoInstance({
    method: 'POST',
    url: '/list-exsisting-characters',
    data
  })
}

function createCharacter(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/generate-character',
    data
  })
}

function updateCharacter(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/update-character',
    data
  })
}

function generateImageDeepAI(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/deepai-image-generate',
    data
  })
}

function generateImageCraiyon(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/craiyon-character-image-generate',
    data
  })
}

function editImageDeepAI(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/deepai-image-edit',
    data
  })
}

function generateLumaVideo(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/luma-video-generate',
    data
  })
}

function generateTransition(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/video-transitions',
    data
  })
}

function generateVideoDeepAI(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/deepai-generate',
    data
  })
}

function getTaskStatus(id) {
  return draftVideoInstance({
    method: 'GET',
    url: `/status/${id}`
  })
}

function synthesizeVoicePreview(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/synthesize-voice',
    data
  })
}

// Get AI Videos with pagination
function getAiVideos(offset = 0, limit = 5) {
  return http({
    method: 'GET',
    url: `/ai-videos?offset=${offset}&limit=${limit}`
  })
}

// Get AI Video by ID
function getAiVideoById(id) {
  console.log(`Get AI Video by ID: ${id}`)
  return http({
    method: 'GET',
    url: `/ai-videos/${id}`
  })
}

// Create AI Video
function createAiVideo(data) {
  return http({
    method: 'POST',
    url: '/ai-videos',
    data
  })
}

// Update AI Video
function updateAiVideo(id, data) {
  return http({
    method: 'PUT',
    url: `/ai-videos/${id}`,
    data
  })
}

// Delete AI Video
function deleteAiVideo(id) {
  return http({
    method: 'DELETE',
    url: `/ai-videos/${id}`
  })
}

function generateLocationReference(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/location-refrence-generator',
    data
  })
}

function generatePropReference(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/props-reference-generator',
    data
  })
}

const buildQuery = params => {
  const query = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value)
    }
  })

  const queryString = query.toString()
  return queryString ? `?${queryString}` : ''
}

function listOutfits(params = {}) {
  const query = buildQuery({
    page: params.page || 1,
    page_size: params.page_size || params.pageSize || 20,
    sort_by: params.sort_by,
    sort_order: params.sort_order
  })

  return draftVideoInstance({
    method: 'GET',
    url: `/outfit/list${query}`
  })
}

function searchOutfits(params = {}) {
  const query = buildQuery({
    q: params.q || params.query,
    page: params.page || 1,
    page_size: params.page_size || params.pageSize || 20
  })

  return draftVideoInstance({
    method: 'GET',
    url: `/outfit/search${query}`
  })
}

function filterOutfits(params = {}) {
  const query = buildQuery({
    style: params.style,
    season: params.season,
    occasion: params.occasion,
    page: params.page || 1,
    page_size: params.page_size || params.pageSize || 20,
    sort_by: params.sort_by,
    sort_order: params.sort_order
  })

  return draftVideoInstance({
    method: 'GET',
    url: `/outfit/filter${query}`
  })
}

function getOutfitStats() {
  return draftVideoInstance({
    method: 'GET',
    url: '/outfit/stats'
  })
}

function getOutfitByTag(tag) {
  return draftVideoInstance({
    method: 'GET',
    url: `/outfit/${encodeURIComponent(tag)}`
  })
}

function getOutfitViews(tag) {
  return draftVideoInstance({
    method: 'GET',
    url: `/outfit/${encodeURIComponent(tag)}/views`
  })
}

function deleteOutfitByTag(tag) {
  return draftVideoInstance({
    method: 'DELETE',
    url: `/outfit/${encodeURIComponent(tag)}`
  })
}

// TTS Enhanced API - List Available Voices
function listAIVoices(params = {}) {
  return draftVideoInstance({
    method: 'GET',
    url: '/voice/list',
    params
  })
}

function getVoiceFilters() {
  return draftVideoInstance({
    method: 'GET',
    url: '/voice/filters'
  })
}

// Voice synthesis v2 - Design a new voice preview
function synthesizeVoice(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/synthesize-voice',
    data
  })
}

// Voice synthesis v2 - Generate TTS with designed or cloned voice
function generateTtsV2(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/generate-tts-v2',
    data
  })
}

// TTS Enhanced API - Generate Single Voice Audio
function generateAudio(data) {
  // Expected data format:
  // {
  //   voice_id: string,
  //   text: string,
  //   speed_factor?: number (0.5-2.0, default 1.0),
  //   exaggeration?: number (0.1-2.0, default 1.0),
  //   cfg_weight?: number (0.0-1.0, default 0.8),
  //   pause_duration?: number (0.0-2.0, default 0.0),
  //   use_emotion_matching?: boolean (default false)
  // }
  return draftVideoInstance({
    method: 'POST',
    url: '/tts-enhanced',
    data: {
      action: 'generate_audio',
      ...data
    }
  })
}

// TTS Enhanced API - Generate Dialogue
function generateDialogue(data) {
  // Expected data format:
  // {
  //   turns: array of [voice_id, text] pairs,
  //   silence_duration?: number (0.0-2.0, default 0.5),
  //   global_speed_factor?: number (0.5-2.0, default 1.0)
  // }
  return draftVideoInstance({
    method: 'POST',
    url: '/tts-enhanced',
    data: {
      action: 'generate_dialogue',
      ...data
    }
  })
}

function regenerateVoiceover(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/tts-enhanced',
    data: {
      action: 'regenerate_scene_audio',
      ...data
    }
  })
}

async function uploadCustomVoice(formData, token) {
  try {
    const voiceUploadUrl = `${config.videoGenerationUrl.replace(
      /\/?$/,
      '/'
    )}voice/upload`
    const response = await axios.post(voiceUploadUrl, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    console.log('Upload successful:', response)
    return response
  } catch (error) {
    console.error('Upload error:', error)
    throw error
  }
}

async function uploadVoiceFromUrl(formData, token) {
  try {
    const voiceUploadUrl = `${config.videoGenerationUrl.replace(
      /\/?$/,
      '/'
    )}voice/upload`
    const response = await axios.post(voiceUploadUrl, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } catch (error) {
    console.error('URL upload error:', error)
    throw error
  }
}

function deleteVoice(voiceId) {
  return draftVideoInstance({
    method: 'DELETE',
    url: `/voice/${encodeURIComponent(String(voiceId || ''))}`
  })
}

function getVoiceRecommendation(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/get-voice-recommendation',
    data
  })
}

function generateSceneAudio(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/generate-scene-audio',
    data
  })
}

function clusterScenesWithAudio(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/cluster-scenes-with-audio',
    data
  })
}

function distributeStoryVoiceover(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/distribute-story-voiceover',
    data
  })
}

function calculateDurations(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/calculate-durations-v2',
    data
  })
}

function getSceneTimeline(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/get-scene-timeline',
    data
  })
}

function regenerateSegment(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/regenerate-segment',
    data
  })
}

function updatePause(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/update-pause',
    data
  })
}

function updateSegmentText(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/update-segment-text',
    data
  })
}

function generateAudioSequences(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/generate-audio-sequences',
    data
  })
}

function assembleScenesWithAudio(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/assemble-scenes-with-audio-and-transitions',
    data
  })
}

function assembleScenesWithAudioAndDialogue(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/assemble-scenes-with-audio-dialogue-and-transitions',
    data
  })
}

function assembleScenesDialogueOnly(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/assemble-scenes-with-dialogue-and-transitions',
    data
  })
}

function generateImageWithReferenceNanoBanana(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/nano-banana-image-generate-with-reference',
    data
  })
}

function generateDraftVideo(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/drafts-generation-mode-v2',
    data
  })
}

function editVideo(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/video-edit',
    data
  })
}

function prepareAdvancedVideoEditor(data) {
  return axios({
    method: 'POST',
    url: 'https://video-editor.sharelookapp.com/prepare-edit',
    data
  })
}

function getPresignedUrls(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/get-presigned-urls',
    data
  })
}

function generateNewStyle(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/generate-new-style',
    data
  })
}

function listEditingStyles(data = {}) {
  console.log('listEditingStyles called with data:', data)
  return draftVideoInstance({
    method: 'POST',
    url: '/list-editing-styles',
    data
  })
}

function deleteEditingStyles(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/delete-editing-styles',
    data
  })
}

function getGeneralPresignedUrls(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/get-presigned-urls-general',
    data
  })
}

function generateOutfit(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/generate-outfit',
    data
  })
}

function generateMusic(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/music-generation',
    data
  })
}

function generateVideoSuggestions(data) {
  return draftVideoInstance({
    method: 'POST',
    url: '/video-suggestions',
    data
  })
}

function getVideoAnalysis(userId, videoId) {
  return draftVideoInstance({
    method: 'GET',
    url: `/analytics/usage/${userId}/video/${videoId}`
  })
}

function checkAccess() {
  return draftVideoInstance({
    method: 'GET',
    url: '/access-ai-video'
  })
}

const getAiVideoAccessInfo = response => {
  const data = response?.data || {}
  const hasAccess =
    typeof data.status === 'boolean'
      ? data.status
      : Boolean(data.output || data.access)

  return {
    hasAccess,
    onboarding: data.onboarding || null
  }
}

const BRAND_ONBOARDING_API_PREFIX = '/api/v1/brand'
const CREATIVE_DIRECTION_API_PREFIX = '/api/v1/creative-direction'
const CREATIVE_DIRECTION_TIMEOUT_MS = 20 * 60 * 1000

const getBrandOnboardingBaseUrl = () => {
  const explicitUrl = process.env.REACT_APP_BRAND_ONBOARDING_URL
  const fallbackUrl =
    process.env.REACT_APP_VIDEO_GENERATOR_URL || config.videoGenerationUrl
  const baseUrl = explicitUrl || fallbackUrl || ''

  return String(baseUrl)
    .replace(/\/+$/, '')
    .replace(/\/v1$/, '')
}

const getBrandOnboardingUrl = path => {
  const baseUrl = getBrandOnboardingBaseUrl()
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  if (baseUrl.endsWith(BRAND_ONBOARDING_API_PREFIX)) {
    return `${baseUrl}${normalizedPath}`
  }

  if (baseUrl.endsWith('/api/v1')) {
    return `${baseUrl}/brand${normalizedPath}`
  }

  return `${baseUrl}${BRAND_ONBOARDING_API_PREFIX}${normalizedPath}`
}

const getBrandOnboardingResolvedUrl = url => {
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url

  const normalizedUrl = url.startsWith('/') ? url : `/${url}`

  if (normalizedUrl.startsWith(BRAND_ONBOARDING_API_PREFIX)) {
    const baseUrl = getBrandOnboardingBaseUrl()
    const appBaseUrl = baseUrl
      .replace(new RegExp(`${BRAND_ONBOARDING_API_PREFIX}$`), '')
      .replace(/\/api\/v1$/, '')

    return `${appBaseUrl}${normalizedUrl}`
  }

  return getBrandOnboardingUrl(normalizedUrl)
}

const getCreativeDirectionBaseUrl = () => {
  const explicitUrl = process.env.REACT_APP_CREATIVE_DIRECTION_URL
  const fallbackUrl =
    process.env.REACT_APP_VIDEO_GENERATOR_URL || config.videoGenerationUrl
  const baseUrl = explicitUrl || fallbackUrl || ''

  return String(baseUrl).replace(/\/+$/, '')
}

const getCreativeDirectionUrl = path => {
  const baseUrl = getCreativeDirectionBaseUrl()
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  if (baseUrl.endsWith(CREATIVE_DIRECTION_API_PREFIX)) {
    return `${baseUrl}${normalizedPath}`
  }

  if (baseUrl.endsWith('/api/v1')) {
    return `${baseUrl}/creative-direction${normalizedPath}`
  }

  if (baseUrl.endsWith('/creative-direction')) {
    const appBaseUrl = baseUrl
      .replace(/\/creative-direction$/, '')
      .replace(/\/api\/v1$/, '')

    return `${appBaseUrl}${CREATIVE_DIRECTION_API_PREFIX}${normalizedPath}`
  }

  return `${baseUrl}${CREATIVE_DIRECTION_API_PREFIX}${normalizedPath}`
}

const getBrandAuthHeaders = async () => {
  try {
    const session = await getSession()
    return {
      Authorization: `Bearer ${session.idToken.jwtToken}`
    }
  } catch (error) {
    return {}
  }
}

const getFilenameFromContentDisposition = (contentDisposition, fallback) => {
  if (!contentDisposition) return fallback

  const utfMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
  if (utfMatch?.[1]) {
    return decodeURIComponent(utfMatch[1].replace(/"/g, ''))
  }

  const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i)
  return filenameMatch?.[1] || fallback
}

const getBrandJsonAssetValue = (payload, assetType) => {
  if (!payload) return ''

  const data = payload.data || payload
  const candidateKeys =
    assetType === 'image'
      ? [
        'image_url',
        'imageUrl',
        'brand_image_url',
        'brandImageUrl',
        'asset_url',
        'assetUrl',
        'signed_url',
        'signedUrl',
        'url',
        'image',
        'file_url',
        'fileUrl'
      ]
      : [
        'document_url',
        'documentUrl',
        'brand_document_url',
        'brandDocumentUrl',
        'download_url',
        'downloadUrl',
        'asset_url',
        'assetUrl',
        'signed_url',
        'signedUrl',
        'url',
        'file_url',
        'fileUrl'
      ]

  for (const key of candidateKeys) {
    if (typeof data[key] === 'string' && data[key].trim()) {
      return data[key].trim()
    }
  }

  return ''
}

const getBrandJsonBase64Asset = (payload, assetType) => {
  const data = payload?.data || payload || {}
  const keys =
    assetType === 'image'
      ? ['image_base64', 'imageBase64', 'base64']
      : ['document_base64', 'documentBase64', 'base64']

  for (const key of keys) {
    if (typeof data[key] === 'string' && data[key].trim()) {
      return data[key].trim()
    }
  }

  return ''
}

const getMimeFromBase64Asset = (base64Value, fallbackMime) => {
  if (base64Value.startsWith('data:')) return base64Value
  return `data:${fallbackMime};base64,${base64Value}`
}

const getProtectedBrandAssetBlob = async url => {
  const resolvedUrl = getBrandOnboardingResolvedUrl(url)
  const baseUrl = getBrandOnboardingBaseUrl()
  const shouldUseAuth =
    !/^https?:\/\//i.test(url) ||
    resolvedUrl.includes(BRAND_ONBOARDING_API_PREFIX) ||
    (baseUrl && resolvedUrl.startsWith(baseUrl))
  const headers = shouldUseAuth ? await getBrandAuthHeaders() : {}
  const response = await fetch(resolvedUrl, {
    method: 'GET',
    headers
  })

  if (!response.ok) {
    throw new Error('Failed to load brand asset')
  }

  return {
    blob: await response.blob(),
    contentDisposition: response.headers.get('content-disposition')
  }
}

const brandOnboardingRequest = async ({ method, path, data, responseType }) => {
  const headers = await getBrandAuthHeaders()

  return axios({
    method,
    url: getBrandOnboardingUrl(path),
    data,
    responseType,
    headers
  })
}

const parseSsePart = part => {
  const lines = String(part || '').replace(/\r/g, '').split('\n')
  let event = 'message'
  let data = ''

  lines.forEach(line => {
    const normalizedLine = line.trimEnd()

    if (normalizedLine.startsWith('event:')) {
      event = normalizedLine.slice(6).trim()
      return
    }

    if (normalizedLine.startsWith('data:')) {
      const value = normalizedLine.slice(5).replace(/^ /, '')
      data += data ? `\n${value}` : value
    }
  })

  if (data === '[DONE]') {
    return {
      event: 'done',
      data: {}
    }
  }

  let parsedData = data

  if (data) {
    try {
      parsedData = JSON.parse(data)
    } catch (error) {
      parsedData = data
    }
  }

  return {
    event,
    data: parsedData || {}
  }
}

const streamBrandOnboardingRequest = async ({
  path,
  method = 'POST',
  headers = {},
  body,
  onToken,
  onMetadata,
  onFileInfo,
  onDone
}) => {
  const authHeaders = await getBrandAuthHeaders()
  const response = await fetch(getBrandOnboardingUrl(path), {
    method,
    headers: {
      ...authHeaders,
      ...headers
    },
    body
  })

  if (!response.ok) {
    let errorMessage = 'Brand onboarding request failed'
    try {
      const errorText = await response.text()
      const errorPayload = errorText ? JSON.parse(errorText) : {}
      errorMessage =
        errorPayload?.error?.message || errorPayload?.message || errorMessage
    } catch (error) {
      // Keep the generic message when the error body is not JSON.
    }

    throw new Error(errorMessage)
  }

  if (!response.body) {
    onDone && onDone()
    return
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  while (true) {
    const { done, value } = await reader.read()
    if (done) break

    buffer += decoder.decode(value, { stream: true })
    const parts = buffer.split('\n\n')
    buffer = parts.pop()

    for (const part of parts) {
      const parsed = parseSsePart(part)
      if (!parsed) continue

      switch (parsed.event) {
        case 'file_uploaded':
          onFileInfo && onFileInfo(parsed.data)
          break
        case 'token':
          onToken &&
            onToken(
              typeof parsed.data === 'string'
                ? parsed.data
                : parsed.data.text || parsed.data.message || ''
            )
          break
        case 'metadata':
          onMetadata && onMetadata(parsed.data)
          break
        case 'done':
          onDone && onDone()
          return
        default:
          break
      }
    }
  }

  onDone && onDone()
}

const creativeDirectionRequest = async ({ method, path, data }) => {
  const headers = await getBrandAuthHeaders()
  const isMultipart =
    typeof FormData !== 'undefined' && data instanceof FormData

  return axios({
    method,
    url: getCreativeDirectionUrl(path),
    data,
    headers: {
      ...headers,
      ...(isMultipart ? {} : { 'Content-Type': 'application/json' })
    },
    timeout: CREATIVE_DIRECTION_TIMEOUT_MS
  })
}

const streamCreativeDirectionRequest = async ({
  path,
  method = 'POST',
  headers = {},
  body,
  onToken,
  onMetadata,
  onError,
  onDone
}) => {
  const authHeaders = await getBrandAuthHeaders()
  const response = await fetch(getCreativeDirectionUrl(path), {
    method,
    headers: {
      ...authHeaders,
      ...headers
    },
    body
  })

  if (!response.ok) {
    let errorMessage = 'Creative direction request failed'
    try {
      const errorText = await response.text()
      const errorPayload = errorText ? JSON.parse(errorText) : {}
      errorMessage =
        errorPayload?.detail ||
        errorPayload?.error?.message ||
        errorPayload?.message ||
        errorMessage
    } catch (error) {
      // Keep the generic message when the error body is not JSON.
    }

    throw new Error(errorMessage)
  }

  if (!response.body) {
    onDone && onDone()
    return
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  while (true) {
    const { done, value } = await reader.read()
    if (done) break

    buffer += decoder.decode(value, { stream: true })
    const parts = buffer.split('\n\n')
    buffer = parts.pop()

    for (const part of parts) {
      const parsed = parseSsePart(part)
      if (!parsed) continue

      switch (parsed.event) {
        case 'token':
          onToken && onToken(parsed.data.text || '')
          break
        case 'message':
          onToken &&
            onToken(
              typeof parsed.data === 'string'
                ? parsed.data
                : parsed.data.text || parsed.data.message || ''
            )
          break
        case 'metadata':
          onMetadata && onMetadata(parsed.data)
          break
        case 'error':
          onError && onError(parsed.data.message || 'Creative direction stream failed')
          break
        case 'done':
          onDone && onDone()
          return
        default:
          break
      }
    }
  }

  onDone && onDone()
}

function createBrandOnboardingSession(organizationId) {
  return brandOnboardingRequest({
    method: 'POST',
    path: '/sessions',
    data: {
      organization_id: organizationId
    }
  })
}

function getBrandOnboardingSessionStatus(sessionId) {
  return brandOnboardingRequest({
    method: 'GET',
    path: `/sessions/${sessionId}/status`
  })
}

function finalizeBrandOnboardingSession(sessionId) {
  return brandOnboardingRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/finalize`,
    data: {
      confirm: true
    }
  })
}

function getBrandOnboardingProfile(sessionId) {
  return brandOnboardingRequest({
    method: 'GET',
    path: `/sessions/${sessionId}/profile`
  })
}

function streamBrandGuidelinesUpload(sessionId, file, handlers = {}) {
  const formData = new FormData()
  formData.append('file', file)

  return streamBrandOnboardingRequest({
    path: `/sessions/${sessionId}/upload`,
    body: formData,
    ...handlers
  })
}

function streamBrandOnboardingChat(sessionId, message, handlers = {}) {
  return streamBrandOnboardingRequest({
    path: `/sessions/${sessionId}/chat`,
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ message }),
    ...handlers
  })
}

async function getBrandOnboardingAssetUrl(sessionId, assetType) {
  const headers = await getBrandAuthHeaders()
  const response = await fetch(
    getBrandOnboardingUrl(`/sessions/${sessionId}/${assetType}`),
    {
      method: 'GET',
      headers
    }
  )

  if (!response.ok) {
    throw new Error(`Failed to load brand ${assetType}`)
  }

  const contentType = response.headers.get('content-type') || ''

  if (contentType.includes('application/json')) {
    const payload = await response.json()
    const base64Asset = getBrandJsonBase64Asset(payload, assetType)

    if (base64Asset) {
      const fallbackMime =
        assetType === 'image'
          ? 'image/png'
          : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      return getMimeFromBase64Asset(base64Asset, fallbackMime)
    }

    const assetUrl = getBrandJsonAssetValue(payload, assetType)

    if (assetUrl) {
      if (assetUrl.startsWith('data:')) return assetUrl

      const { blob } = await getProtectedBrandAssetBlob(assetUrl)
      return URL.createObjectURL(blob)
    }

    throw new Error(`Brand ${assetType} response did not include a renderable asset`)
  }

  const blob = await response.blob()
  return URL.createObjectURL(blob)
}

function createCreativeDirectionSession(data) {
  return creativeDirectionRequest({
    method: 'POST',
    path: '/sessions',
    data
  })
}

function getCreativeDirectionSessionStatus(sessionId) {
  return creativeDirectionRequest({
    method: 'GET',
    path: `/sessions/${sessionId}/status`
  })
}

function getCreativeDirectionSessionFull(sessionId) {
  return creativeDirectionRequest({
    method: 'GET',
    path: `/sessions/${sessionId}/full`
  })
}

function deleteCreativeDirectionSession(sessionId) {
  return creativeDirectionRequest({
    method: 'DELETE',
    path: `/sessions/${sessionId}`
  })
}

function streamCreativeDirectionChat(sessionId, message, handlers = {}) {
  return streamCreativeDirectionRequest({
    path: `/sessions/${sessionId}/chat`,
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      message,
      movement: handlers.movement || null
    }),
    ...handlers
  })
}

function uploadCreativeDirectionReference(sessionId, file) {
  const formData = new FormData()
  formData.append('file', file)

  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/upload-ref`,
    data: formData
  })
}

function uploadCreativeDirectionUploads(sessionId, files = []) {
  const formData = new FormData()
  const normalizedFiles = Array.isArray(files) ? files : [files]

  normalizedFiles.filter(Boolean).forEach(file => {
    formData.append('files', file)
  })

  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/uploads`,
    data: formData
  })
}

const normalizeDraftVideoUploadPath = path => {
  const normalizedPath = String(path || '').startsWith('/')
    ? String(path || '')
    : `/${path || ''}`
  const draftBaseUrl = String(
    process.env.REACT_APP_VIDEO_GENERATOR_URL || config.videoGenerationUrl || ''
  ).replace(/\/+$/, '')

  if (draftBaseUrl.endsWith('/api/v1') && normalizedPath.startsWith('/api/v1/')) {
    return normalizedPath.replace('/api/v1', '')
  }

  return normalizedPath
}

const getDraftVideoUploadUrl = path => {
  const draftBaseUrl = String(
    process.env.REACT_APP_VIDEO_GENERATOR_URL || config.videoGenerationUrl || ''
  ).replace(/\/+$/, '')

  return `${draftBaseUrl}${normalizeDraftVideoUploadPath(path)}`
}

async function uploadCreativeDirectionReferenceToPath(uploadPath, files = []) {
  const formData = new FormData()
  const headers = await getBrandAuthHeaders()
  const normalizedFiles = (Array.isArray(files) ? files : [files])
    .map(file => file && (file.originFileObj || file))
    .filter(Boolean)

  normalizedFiles.forEach(file => {
    formData.append('files', file)
  })

  const response = await fetch(getDraftVideoUploadUrl(uploadPath), {
    method: 'POST',
    headers,
    body: formData
  })

  const contentType = response.headers.get('content-type') || ''
  const data = contentType.includes('application/json')
    ? await response.json()
    : await response.text()

  if (!response.ok) {
    const detail =
      data && typeof data === 'object'
        ? data.detail || data.error || data.message
        : data
    throw new Error(detail || 'Reference upload failed')
  }

  return { data }
}

function sendCreativeDirectionAgentChat(sessionId, message, uploads = []) {
  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/agent-chat`,
    data: {
      message,
      uploads
    }
  })
}

function getCreativeDirectionEntities(sessionId, kind) {
  return creativeDirectionRequest({
    method: 'GET',
    path: `/sessions/${sessionId}/entities/${kind}`
  })
}

function sendCreativeDirectionEditChat(
  sessionId,
  kind,
  targetId,
  message,
  files = []
) {
  const formData = new FormData()
  const normalizedFiles = Array.isArray(files) ? files : [files]

  formData.append('message', message)
  normalizedFiles.filter(Boolean).forEach(file => {
    formData.append('files', file)
  })

  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/edit-chat/${kind}/${targetId}`,
    data: formData
  })
}

function getCreativeDirectionEditChat(sessionId, kind, targetId) {
  return creativeDirectionRequest({
    method: 'GET',
    path: `/sessions/${sessionId}/edit-chat/${kind}/${targetId}`
  })
}

function saveCreativeDirectionVision(sessionId, vision) {
  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/vision`,
    data: { vision }
  })
}

function synthesizeCreativeDirectionVision(sessionId, chat) {
  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/vision/synthesize`,
    data: { chat }
  })
}

function advanceCreativeDirectionSession(sessionId) {
  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/advance`
  })
}

function extractCreativeDirectionPhase(sessionId) {
  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/extract`
  })
}

function generateCreativeDirectionPhase(sessionId) {
  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/generate`
  })
}

function getCreativeDirectionGenerationStatus(sessionId) {
  return creativeDirectionRequest({
    method: 'GET',
    path: `/sessions/${sessionId}/generation-status`
  })
}

function getCreativeDirectionTaskStatus(taskId) {
  return creativeDirectionRequest({
    method: 'GET',
    path: `/status/${taskId}`
  })
}

function updateCreativeDirectionEntity(sessionId, kind, entityId, data) {
  return creativeDirectionRequest({
    method: 'PUT',
    path: `/sessions/${sessionId}/entities/${kind}/${entityId}`,
    data
  })
}

function verifyCreativeDirectionEntity(sessionId, kind, entityId, data) {
  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/entities/${kind}/${entityId}/verify`,
    data
  })
}

function manageCreativeDirectionStoryboardPlan(sessionId, action) {
  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/storyboard/plan`,
    data: { action }
  })
}

function finalizeCreativeDirectionSession(sessionId) {
  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/finalize`
  })
}

function getCreativeDirectionBible(sessionId) {
  return creativeDirectionRequest({
    method: 'GET',
    path: `/sessions/${sessionId}/bible`
  })
}

function regenerateCreativeDirectionAsset(sessionId, assetId, notes = '') {
  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/assets/${assetId}/regenerate`,
    data: { notes }
  })
}

function approveCreativeDirectionAsset(
  sessionId,
  assetId,
  approved = true,
  notes = ''
) {
  return creativeDirectionRequest({
    method: 'POST',
    path: `/sessions/${sessionId}/assets/${assetId}/approve`,
    data: { approved, notes }
  })
}

async function downloadBrandOnboardingDocument(sessionId, fallbackName) {
  const headers = await getBrandAuthHeaders()
  const response = await fetch(
    getBrandOnboardingUrl(`/sessions/${sessionId}/document`),
    {
      method: 'GET',
      headers
    }
  )

  if (!response.ok) {
    throw new Error('Failed to download brand document')
  }

  const contentType = response.headers.get('content-type') || ''
  let blob
  let contentDisposition = response.headers.get('content-disposition')

  if (contentType.includes('application/json')) {
    const payload = await response.json()
    const base64Asset = getBrandJsonBase64Asset(payload, 'document')
    const assetUrl = getBrandJsonAssetValue(payload, 'document')

    if (base64Asset) {
      const dataUrl = getMimeFromBase64Asset(
        base64Asset,
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      )
      const base64Response = await fetch(dataUrl)
      blob = await base64Response.blob()
    } else if (assetUrl) {
      const assetResponse = await getProtectedBrandAssetBlob(assetUrl)
      blob = assetResponse.blob
      contentDisposition = assetResponse.contentDisposition
    } else {
      throw new Error('Brand document response did not include a downloadable asset')
    }
  } else {
    blob = await response.blob()
  }

  const filename = getFilenameFromContentDisposition(
    contentDisposition,
    `${fallbackName || 'brand-profile'}.docx`
  )
  const objectUrl = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(objectUrl)
}

export {
  changeMachineState,
  generateVideo,
  generateShots,
  mapCharacterToShots,
  groupShotsToScenes,
  generateVideoStory,
  getAvailableCharacters,
  createCharacter,
  updateCharacter,
  generateImageDeepAI,
  generateVideoDeepAI,
  generateTransition,
  getAiVideos,
  getAiVideoById,
  createAiVideo,
  updateAiVideo,
  deleteAiVideo,
  getTaskStatus,
  synthesizeVoicePreview,
  generateLocationReference,
  generatePropReference,
  generateImageCraiyon,
  editImageDeepAI,
  generateLumaVideo,
  listOutfits,
  searchOutfits,
  filterOutfits,
  getOutfitStats,
  getOutfitByTag,
  getOutfitViews,
  deleteOutfitByTag,
  listAIVoices,
  getVoiceFilters,
  synthesizeVoice,
  generateTtsV2,
  generateAudio,
  generateDialogue,
  uploadCustomVoice,
  uploadVoiceFromUrl,
  deleteVoice,
  getVoiceRecommendation,
  generateSceneAudio,
  clusterScenesWithAudio,
  distributeStoryVoiceover,
  calculateDurations,
  assembleScenesWithAudio,
  getSceneTimeline,
  regenerateSegment,
  updatePause,
  updateSegmentText,
  generateAudioSequences,
  generateImageWithReferenceNanoBanana,
  generateDraftVideo,
  editVideo,
  prepareAdvancedVideoEditor,
  getPresignedUrls,
  generateNewStyle,
  listEditingStyles,
  deleteEditingStyles,
  getGeneralPresignedUrls,
  generateOutfit,
  generateMusic,
  generateVideoSuggestions,
  getVideoAnalysis,
  assembleScenesWithAudioAndDialogue,
  assembleScenesDialogueOnly,
  regenerateVoiceover,
  checkAccess,
  getAiVideoAccessInfo,
  createBrandOnboardingSession,
  getBrandOnboardingSessionStatus,
  finalizeBrandOnboardingSession,
  getBrandOnboardingProfile,
  streamBrandGuidelinesUpload,
  streamBrandOnboardingChat,
  getBrandOnboardingAssetUrl,
  getBrandOnboardingResolvedUrl,
  downloadBrandOnboardingDocument,
  createCreativeDirectionSession,
  getCreativeDirectionSessionFull,
  getCreativeDirectionSessionStatus,
  deleteCreativeDirectionSession,
  streamCreativeDirectionChat,
  uploadCreativeDirectionReference,
  uploadCreativeDirectionReferenceToPath,
  uploadCreativeDirectionUploads,
  sendCreativeDirectionAgentChat,
  getCreativeDirectionEntities,
  sendCreativeDirectionEditChat,
  getCreativeDirectionEditChat,
  saveCreativeDirectionVision,
  synthesizeCreativeDirectionVision,
  advanceCreativeDirectionSession,
  extractCreativeDirectionPhase,
  generateCreativeDirectionPhase,
  getCreativeDirectionGenerationStatus,
  getCreativeDirectionTaskStatus,
  updateCreativeDirectionEntity,
  verifyCreativeDirectionEntity,
  manageCreativeDirectionStoryboardPlan,
  finalizeCreativeDirectionSession,
  getCreativeDirectionBible,
  regenerateCreativeDirectionAsset,
  approveCreativeDirectionAsset
}
